import { inject, injectable } from 'inversify';
import { autorun, makeAutoObservable } from 'mobx';
import { ProfileModule } from '@mobx/services/profile';
import { logout } from '@mobx/root';
import { type AuthService, AuthServiceIdentifier } from '@shared/types/mobx/services/auth';
import { type RolesService, RolesServiceIdentifier } from '@shared/types/mobx/services/roles';
import { getSelectableRoles } from '@shared/utils/helpers/selectableRoles';

@injectable()
export class CabinetAccountViewModel {
  userInfo: any = null;

  isOpen;

  // eslint-disable-next-line no-unused-vars
  constructor(
    private profileModule: ProfileModule,
    @inject(AuthServiceIdentifier) private authModule: AuthService,
    @inject(RolesServiceIdentifier) private rolesModule: RolesService
  ) {
    makeAutoObservable(this);

    this.isOpen = false;
    this.userInfo = this.profileModule.userData.info;
    autorun(() => {
      this.userInfo = this.profileModule.userData.info;
    });
  }

  /**
   * Показывать ли пункт «Сменить роль» (дефект «сброс роли на ABONENT после очистки сессии»).
   * Только если на экране выбора больше одной роли — считаем той же функцией, что и сам экран
   * (`getSelectableRoles`, учитывает виртуальную роль «Доверенный»). С одной ролью экран выбора
   * бесполезен: гвард RoleSelectedGuard выбирает её автоматически.
   */
  get canChangeRole(): boolean {
    return getSelectableRoles(this.rolesModule.roles).length > 1;
  }

  open = () => {
    this.isOpen = true;
  };

  close = () => {
    this.isOpen = false;
  };

  logout = () => {
    // Оркестратор из root: authModule.logout() + очистка persist всех сессионных сторов,
    // иначе старая роль/данные протекают между входами.
    logout();
    this.close();
  };
}
